var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"provincias container"},[_c('custom-select',{attrs:{"label":"Provincia","value":_vm.value,"name":_vm.name,"items":_vm.provincias,"quantumObfuscate":_vm.quantumObfuscate},on:{"input":_vm.onChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }